/* eslint-disable no-undef, no-underscore-dangle */
import { useContext, useEffect } from 'react';
import { useOtherSettings } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';
import { useNativeAppStore } from '@namespace/native-app';
import { USER_ROLES, UserContext } from '@namespace/user';
import { useSmarticoPopupSuspended } from '../useSmarticoPopupSuspended';
import { useSmarticoSuspendCallback } from '../useSmarticoSuspendCallback';

const SMARTICO_CONNECT_LINK = 'https://libs.smartico.ai/smartico.js';

const loadSmartico = (cb) => {
  return new Promise((resolve, reject) => {
    if (!document.getElementById('smarticoScript')) {
      const script = document.createElement('script');
      script.src = SMARTICO_CONNECT_LINK;
      script.id = 'smarticoScript';
      script.onload = () => {
        cb();
        resolve();
      };
      script.onerror = reject;
      document.body.append(script);
    } else {
      resolve();
    }
  });
};

export const useSmarticoWidget = () => {
  const [user] = useContext(UserContext);
  const { language } = useI18n();

  const { role, id: userId } = user;
  const isLoggedInUser = role === USER_ROLES.USER;
  const { smarticoWidgetSettings = {} } = useOtherSettings();
  const {
    isSmarticoEnabled,
    isSmarticoEnabledForTesters,
    smarticoLabelKey,
    smarticoBrandKey
  } = smarticoWidgetSettings;

  const { isNativeApp, nativeAppConfig, isNativeAppConfigLoaded } =
    useNativeAppStore();

  const { smartico: nativeSmarticoConfig } = nativeAppConfig;

  const { enable = false } = nativeSmarticoConfig || {};

  const suspendSmartico = useSmarticoSuspendCallback();
  const isMatch = useSmarticoPopupSuspended();

  useEffect(() => {
    if (
      isLoggedInUser &&
      (isSmarticoEnabled ||
        (isSmarticoEnabledForTesters &&
          window.location.host.includes('prev'))) &&
      isNativeAppConfigLoaded &&
      (!isNativeApp || (isNativeApp && enable))
    ) {
      window._smartico_user_id = userId;
      window._smartico_language = language;

      // uncomment this if you want to run it locally
      // window._smartico_allow_localhost = true;
    }

    if (window._smartico_user_id && window._smartico_language) {
      loadSmartico(() => {
        _smartico.init(smarticoLabelKey, {
          brand_key: smarticoBrandKey
        });
        _smartico.on('init', (errCode) => {
          if (errCode) {
            console.log('smartico init error ', errCode);
            return;
          }
          suspendSmartico(isMatch, isMatch);
        });
      });
    }
  }, [isLoggedInUser, isNativeAppConfigLoaded]);

  useEffect(() => {
    if (window._smartico_user_id && window._smartico_language !== language) {
      window._smartico_language = language;
    }
  }, [language]);
};
